<asw-criteo-alignment [criteoAlignmentInfo]="criteoData"></asw-criteo-alignment>
